import { pickThemeFontStyles } from '@/theme';
import { TreeSelect } from 'antd';
import styled from 'styled-components';

export const StyledTreeSelect = styled(TreeSelect)`
  width: 100%;
  text-align: left;
`;

export const StyledSelectDescription = styled.div`
  text-align: left;
  margin-top: 0.125rem;
  ${pickThemeFontStyles('12', '22', 'NORMAL')};
`;
